const TypingIndicator = () => {
  return (
    <div
      className="bg-white flex items-center justify-center"
      style={{
        width: "62px",
        height: "26px",
        borderRadius: "9px",
        boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
        position: "relative",
      }}
    >
      <div
        className="flex items-center"
        style={{
          width: "30px",
          height: "6px",
          gap: "6px",
          position: "absolute",
          left: "16px",
          top: "10px",
        }}
      >
        <style>{`
          @keyframes typingBounce {
            0%, 80%, 100% {
              transform: scale(0.8);
              opacity: 0.5;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}</style>

        <div
          className="rounded-full"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#D9D9D9",
            animation: "typingBounce 2.2s infinite ease-in-out",
            animationDelay: "0s",
          }}
        />

        <div
          className="rounded-full"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#D9D9D9",
            animation: "typingBounce 2.2s infinite ease-in-out",
            animationDelay: "0.3s",
          }}
        />

        <div
          className="rounded-full"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#D9D9D9",
            animation: "typingBounce 2.2s infinite ease-in-out",
            animationDelay: "0.6s",
          }}
        />
      </div>
    </div>
  );
};

export default TypingIndicator;
